import React, {useEffect, useState} from 'react';
import {Image, Text, View} from '@react-pdf/renderer';
import styles from './styles';

const FooterPDF = () => {
  const [signatureUrl, setSignatureUrl] = useState(null);
  useEffect(() => {
    const storedSignatureUrl = localStorage.getItem('signatureUrl');
    if (storedSignatureUrl) {
      setSignatureUrl(storedSignatureUrl);
    }
  }, []);

  return (
    <View style={styles.footer}>
      <View style={[styles.row, styles.spaceBetween]}>
        <View style={[styles.row, styles.footerSign, {position: 'relative'}]}>
          <Text style={styles.text}>Serviseri:</Text>
          {signatureUrl ? (
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <View style={[styles.flex1, styles.borderBottom]} />
              <Text style={styles.text}>_____________________________________</Text>
              <Image
                src={signatureUrl}
                alt="signature"
                style={{
                  width: 50,
                  height: 50,
                  position: 'absolute',
                  top: -20,
                  left: 20,
                }}
              />
            </View>
          ) : (
            <Text style={styles.text}>_____________________________________</Text>
          )}
        </View>
        <View style={[styles.row, styles.footerSign]}>
          <Text style={styles.text}>Klienti:</Text>
          {/* <View style={[styles.flex1, styles.borderBottom]} /> */}
          <Text style={styles.text}>_____________________________________</Text>
        </View>
      </View>
      <View style={styles.center}>
        <Text style={[styles.text, styles.uplift]}>UPLIFT L.L.C</Text>
        <Text style={styles.info}>
          Tel: 048 651 651 &#183; web: www.uplift-ks.com &#183; e-mail:
          info@uplift-ks.com
        </Text>
      </View>
    </View>
  );
};

export default FooterPDF;
